<template>
    <div class="p-4 text-sm text-gray-800">

        <p class="mb-3">
            {{ __('Carica il file delle spedizioni: ogni riga diventa una spedizione da trasmettere nell\'elenco.') }}
            {{ __('Quelle a cui manca qualcosa restano "da completare": aprile con modifica, completale e salvale.') }}
        </p>

        <div class="flex flex-wrap items-center mb-4">
            <input type="file" ref="file" @change="scelto"
                class="text-xs mr-3 mb-2">
            <button type="button" @click="carica" :disabled="!file || inCorso"
                class="text-white text-xs font-bold py-2 px-4 rounded mb-2"
                :class="!file || inCorso ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-800'">
                {{ inCorso ? __('caricamento...') : __('carica file') }}
            </button>
        </div>

        <div v-if="esito">
            <div class="flex flex-wrap mb-3">
                <span class="mr-6"><b>{{ esito.complete }}</b> {{ __('pronte da trasmettere') }}</span>
                <span class="mr-6 text-red-700"><b>{{ esito.da_completare }}</b> {{ __('da completare') }}</span>
                <span class="mr-6 text-gray-600"><b>{{ esito.scartate }}</b> {{ __('non importate') }}</span>
                <button type="button" @click="$emit('elenco')"
                    class="ml-auto text-xs font-bold py-1 px-3 rounded border border-red-600 text-red-600 hover:bg-red-50">
                    {{ __('vai all\'elenco') }}
                </button>
            </div>

            <div class="w-full overflow-x-auto">
                <table class="min-w-full text-xs">
                    <thead>
                        <tr class="text-left text-gray-700 uppercase font-bold border-b border-gray-300">
                            <th class="px-2 py-2">{{ __('Riga') }}</th>
                            <th class="px-2 py-2">{{ __('Rif. DDT') }}</th>
                            <th class="px-2 py-2">{{ __('Esito') }}</th>
                            <th class="px-2 py-2">{{ __('Dettagli') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="r in esito.righe" :key="r.riga" class="border-b border-gray-200 align-top">
                            <td class="px-2 py-2">{{ r.riga }}</td>
                            <td class="px-2 py-2">{{ r.rif_ddt }}</td>
                            <td class="px-2 py-2 font-bold whitespace-nowrap" :class="coloreEsito(r.stato)">
                                {{ scrittaEsito(r.stato) }}
                            </td>
                            <td class="px-2 py-2">
                                <div v-for="(e, i) in r.errori" :key="'e' + i" class="text-red-700">{{ e }}</div>
                                <div v-for="(a, i) in r.avvisi" :key="'a' + i" class="text-gray-600">{{ a }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * Importazione delle spedizioni da file (08/10/2026).
 * Il formato del file lo decide il profilo del cliente, impostato in admin: qui si
 * manda il file cosi' com'e', senza leggerlo. Le spedizioni create sono BOZZE e
 * finiscono nell'elenco come quelle fatte a mano.
 */
export default {
    data() {
        return {
            file: null,
            inCorso: false,
            esito: null
        }
    },
    methods: {
        scelto(ev) {
            this.file = ev.target.files && ev.target.files.length > 0 ? ev.target.files[0] : null;
            this.esito = null;
        },
        scrittaEsito(stato) {
            if (stato === 'BOZZA') return this.__('da trasmettere');
            if (stato === 'DA_COMPLETARE') return this.__('da completare');
            return this.__('non importata');
        },
        coloreEsito(stato) {
            if (stato === 'BOZZA') return 'text-green-700';
            if (stato === 'DA_COMPLETARE') return 'text-red-700';
            return 'text-gray-500';
        },
        async carica() {
            if (!this.file || this.inCorso) return;
            this.inCorso = true;
            try {
                await this.storeLogTime(async () => {
                    const dati = new FormData();
                    dati.append('file', this.file);
                    const res = await this.handleCallback(
                        // con FormData axios mette da solo multipart con il boundary giusto
                        () => this.axios.post(this.$store.getters.uri + '/bollettazione/importa', dati), false);
                    const v = res && res.value ? res.value : res;
                    if (v && Array.isArray(v.righe)) {
                        this.esito = v;
                        // lo stesso file non si ricarica per sbaglio due volte di fila
                        this.file = null;
                        if (this.$refs.file) this.$refs.file.value = '';
                        this.$emit('importato');
                    }
                    return res;
                });
            } finally {
                this.inCorso = false;
            }
        }
    }
}
</script>
